import { jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import LookupGeneric from "./lookupGeneric";
import CourseService from "../../src/Services/Course.service";
const CourseLookup = (props) => {
    return LookupGeneric({
        onChange: props.onChange,
        defaultIds: props.defaultIds,
        fetchItemsById: (ids) => {
            return CourseService.findByIds(ids);
        },
        fetchOptions: (search) => {
            return CourseService.getCourses(search);
        },
        optionRenderer: function courseRenderer(course) {
            return (_jsxs("span", { children: ["[", course.code, "] ", course.name] }));
        },
    });
};
export default CourseLookup;
